import { Record, List, fromJS } from 'immutable'
import _ from 'lodash'

import { ENTITY_SEARCH_END, ENTITY_SEARCH_START, ENTITY_STACK_SEARCH_SET_ENTITIES } from './constants'

const initialState = Record({
    searching: false,
    searchValue: '',
    entities: List(),
})

export default function searchReducer(state = initialState(), action = {}) {
    switch (action.type) {
        case ENTITY_SEARCH_START: {
            const searchValue = _.get(action, 'data.searchValue', {})

            return state.set('searching', true).set('searchValue', searchValue)
        }

        case ENTITY_SEARCH_END: {
            const searchValue = _.get(action, 'data.searchValue', {})

            return state.set('searching', false).set('searchValue', searchValue)
        }
        case ENTITY_STACK_SEARCH_SET_ENTITIES: {
            const entities = _.get(action, 'data.entities', [])

            return state.set('entities', fromJS(entities))
        }
        default:
            return state
    }
}
